// extracted by mini-css-extract-plugin
export var list = "filterTags-module--list--b2993";
export var listItem = "filterTags-module--list-item--e8b9c";